import { gql } from '@apollo/client'
import { CP_FRAGMENT, FUNDING_REQUEST_FRAGMENT, RAW_ASSET_SUM_FRAGMENT, FR_ATTACHED_ASSET_SUM_FRAGMENT, FUNDING_REQUEST_SUM_FRAGMENT, FR_RECONCILE_ASSETD_DETAILS_FRAGMENT, FR_RECONCILE_SUMMARY_DATA_FRAGMENT, RAW_ASSET_DETAILS_DATA_FRAGMENT, RAW_ASSET_DETAILS_SUMMARY_FRAGMENT, RAW_ASSET_NOTE_FRAGMENT, FUNDING_REQUEST_OPTION_FRAGMENT, EXECUTION_SCHEME_OPTION_FRAGMENT } from '../fragments'

export const GET_CP_BY_DATES = gql`
    ${CP_FRAGMENT}
    query CPIssuanceByDates($from_date: String, $to_date: String) {
        getCPIssuanceByDates(fromDate: $from_date, toDate: $to_date) {
          cpData{
            ...CPFragment
          }
          frData{
            cPIssuanceId
            fundingRequestCode
            cpNotionalQtyAllocated
          }
        }
    }
`
export const GET_CP_BY_ID = gql`
    ${CP_FRAGMENT}
    query CPIssuanceById($id: String!, $data_type: String) {
      getCPIssuanceById(id: $id, dataType: $data_type) {
          cpData{
            ...CPFragment
          }
          frData{
            cPIssuanceId
            fundingRequestCode
            cpNotionalQtyAllocated
          }
        }
    }
`
export const GET_FUNDING_REQUEST_BY_STATUS = gql`
  ${FUNDING_REQUEST_SUM_FRAGMENT}
  query FundingRequestByStatus($status: String, $from_date: String!) {
    getFundingRequestByStatus(status: $status, fromDate: $from_date) {
      ...FundingRequestSumFragment
    }
  }
`

export const GET_FUNDING_REQUEST_BY_ID = gql`
  ${FUNDING_REQUEST_FRAGMENT}
  ${RAW_ASSET_NOTE_FRAGMENT}
  query FundingRequestById($fundingRequestId: Int!, $note_user: String!) {
    getFundingRequestByID(fundingRequestId: $fundingRequestId, noteUser: $note_user) {
      fundingRequestDetails {
        ...FundingRequestFragment
      }
      noteData {
        ...RawAssetNoteDataFragment
      }
    }
  }
`

export const GET_RAW_ASSET_DETAILS_BY_ID = gql`
  ${RAW_ASSET_NOTE_FRAGMENT}
  ${RAW_ASSET_DETAILS_DATA_FRAGMENT}
  ${RAW_ASSET_DETAILS_SUMMARY_FRAGMENT}
  ${FUNDING_REQUEST_OPTION_FRAGMENT}
  ${EXECUTION_SCHEME_OPTION_FRAGMENT}
  
  query GetRawAssetDetailsByBatchId(
    $batch_unique_id: String!
    $note_user: String
    $user_running: String
    $return_result_option: String
  ) {
    getRawAssetDetailsByBatchId(
      batchUniqueID: $batch_unique_id
      noteUser: $note_user
      userRunning: $user_running
      returnResultOption: $return_result_option
    ) {
      status
      message
      detailsData {
        ...RawAssetDetailsDataFragment
      }
      summaryData {
        ...RawAssetDetailsSummaryFragment
      }
      noteData {
        ...RawAssetNoteDataFragment
      }
      availFRs {
        ...FundingRequestOptionFragment
      }
      availOEMSExecScheme {
        ...ExecutionSchemeOptionFragment
      }
    }
  }
`

export const GET_ASSET_SUM_BY_DATE = gql`
  ${RAW_ASSET_SUM_FRAGMENT}
  query GetRawAssetSumByDates($startDate: String!, $running_user: String!) {
    getRawAssetSumByDates(startDate: $startDate, userRunning: $running_user) {
      ...RawAssetSumFragment
    }
  }
`

export const GET_ASSET_SUM_UNWIND = gql`
  query GetAssetSumUnwind($returnResultOption: String!, $running_user: String!) {
    getRawAssetSumByOption(returnResultOption: $returnResultOption, userRunning: $running_user) {
      ScheduledTerminationDate
      StatusFRAssetsUnwind
      FundingRequestCode
      TRSFinancingRateValFullyConverted
      Term
      FundingRequestId
      Quantity
      TotalReturnReceiver
      CostNotional
    }
  }
`

export const GET_RATINGS = gql`
  query GetRatingListByVendor($ratingVendor: String!) {
    getRatingListByVendor (ratingVendor: $ratingVendor) {
      rating
      status 
      message
    }
  }
`
export const GET_AVALIBLE_ASSETS_DATE = gql`
  query GetAvailabilityForAssets($process: String!) {
    getAvailabilityForAssets (process: $process) {
      error
      status 
      trade_dates
    }
  }
`

export const GET_ASSETS_WITH_FR_ID = gql`
  ${RAW_ASSET_DETAILS_DATA_FRAGMENT}
  ${FR_ATTACHED_ASSET_SUM_FRAGMENT}
  query GetFundingRequestAssociatedAssetDetailsById($fundingRequestId: Int!, $data_purpose: String) {
    getFundingRequestAssociatedAssetDetailsById(fundingRequestId: $fundingRequestId, dataPurpose: $data_purpose) {
      status
      message
      summaryData {
        ...FRAttachedAssetSumFragment
      }
      detailsData {
        ...RawAssetDetailsDataFragment
      }
    }
  }
`
export const GET_ASSETS_WITH_FR_ID_UNWIND = gql`
  query GetFundingRequestAssociatedAssetDetailsByIdUnwind($fundingRequestId: Int!, $data_purpose: String) {
    getFundingRequestAssociatedAssetDetailsById(fundingRequestId: $fundingRequestId, dataPurpose: $data_purpose) {
      summaryData {
        assetTradeDetails {
          CostNotional
          Quantity
          MarketValue
        }
      }
      detailsData {
        Ticker
        Quantity
        BuyOrSell
        Price
        MarketValue
        Isin
        CostNotional
        Currency
        Country
        Name
      }
    }
  }
`
export const GET_RECONCILE_RESULT_BY_ID = gql`
  ${FR_RECONCILE_SUMMARY_DATA_FRAGMENT}
  ${FR_RECONCILE_ASSETD_DETAILS_FRAGMENT}
  query GetReconcileResultById($batchId: Int!) {
    getReconcileResultById(assetsBatchSummaryId: $batchId) {
      status
      message
      summaryData {
        ...FRReconcileSummaryData
      }
      detailsData {
        batchId
        assets {
          ...FRReconcileAssetDetailsData
        }
      }
    }
  }

`
